import successActionTypes from "./successTypes";

export const setSuccessMessage = (payload) => ({
  type: successActionTypes.SET_SUCCESS_MESSAGE,
  payload,
});
